/**
 * Accelera header nav behavior — matches accelera.us:
 * - Desktop dropdowns open on hover (Dawn's default is click-to-toggle).
 * - The parent item (e.g. "Why Accelera") is itself a link: mouse click
 *   navigates to its data-url (set in snippets/header-dropdown-menu.liquid).
 *   Keyboard and touch users keep Dawn's default toggle behavior, since
 *   they have no hover to open the submenu with.
 */

(function () {
  // Pluralize the quantity unit word ("Pair" / "Pairs") as the stepper
  // value changes (span rendered by main-product.liquid when the
  // quantity block has a unit label).
  document.querySelectorAll('.quantity__unit').forEach(function (unit) {
    var input = unit.closest('quantity-input')?.querySelector('.quantity__input');
    if (!input) return;
    var update = function () {
      var base = unit.getAttribute('data-unit');
      unit.textContent = parseInt(input.value, 10) === 1 ? base : base + 's';
    };
    input.addEventListener('change', update);
    input.addEventListener('input', update);
    // Dawn resets the input programmatically (no event) after cart
    // updates — re-sync shortly after.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(update, 200);
      });
    }
    update();
  });

  // In-cart buy box: when the product is already in the cart, hide the
  // quantity stepper (quantity is managed from the cart) and turn the
  // submit into a "View Cart" link under the "N Pairs already in cart"
  // label. Server-rendered initially (main-product.liquid); this keeps
  // it in sync after AJAX cart changes via data-cart-quantity, which
  // product-info.js refreshes on every cart update.
  document.querySelectorAll('.product-form__submit').forEach(function (btn) {
    var form = btn.closest('form');
    // form.id would resolve to the <input name="id"> control (named
    // properties shadow the id attribute), so read the attribute.
    var formId = form && form.getAttribute('id');
    if (!formId) return;
    var input = document.querySelector('.quantity__input[form="' + formId + '"]');
    if (!input) return;
    var label = btn.querySelector('span') || btn;
    var addLabel = label.textContent.trim();
    var stepper = input.closest('.price-per-item__container');
    var product = btn.closest('.product');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function inCart() {
      return parseInt(input.dataset.cartQuantity || '0', 10) > 0;
    }

    function render() {
      var active = inCart();
      btn.dataset.cartMode = active ? 'view' : 'add';
      label.textContent = active ? 'View Cart' : addLabel;
      if (stepper) stepper.classList.toggle('hidden', active);
      if (product) product.classList.toggle('product--in-cart', active);
    }

    new MutationObserver(render).observe(input, {
      attributes: true,
      attributeFilter: ['data-cart-quantity'],
    });

    btn.addEventListener('click', function (event) {
      if (!inCart()) return; // stock Dawn add-to-cart flow
      event.preventDefault();
      event.stopPropagation();
      window.location.href = root + 'cart';
    });

    render();
  });

  // Reword the Shop Pay installments banner from "4 interest-free
  // installments, or from $X/mo with ..." to "Or as low as $X/mo with
  // ...". The component renders in an open shadow root; only the
  // leading text node is replaced (price, logo, and the sample-plans
  // modal link are untouched), and only when the stock English wording
  // is found — anything else falls back to Shopify's default.
  function rewordInstallments() {
    var applied = false;
    document.querySelectorAll('shopify-payment-terms').forEach(function (terms) {
      var root = terms.shadowRoot;
      var content = root && root.querySelector('#shopify-installments-content');
      var textNode = content && content.firstChild;
      if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return;
      if (/interest-free installments, or from\s*$/i.test(textNode.textContent)) {
        textNode.textContent = 'Or as low as ';
      }
      applied = true;
      // the component can re-render (e.g. price updates); re-apply then
      if (!terms.dataset.accReworded) {
        terms.dataset.accReworded = 'true';
        new MutationObserver(rewordInstallments).observe(root, { childList: true, subtree: true });
      }
    });
    return applied;
  }

  var installmentsTries = 0;
  var installmentsPoll = setInterval(function () {
    if (rewordInstallments() || ++installmentsTries > 40) clearInterval(installmentsPoll);
  }, 250);
  rewordInstallments();

  var desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover)');

  document.querySelectorAll('.header__inline-menu header-menu > details').forEach(function (details) {
    var summary = details.querySelector('summary');
    var listItem = details.closest('li');
    if (!summary || !listItem) return;

    listItem.addEventListener('mouseenter', function () {
      if (!desktopHover.matches) return;
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    listItem.addEventListener('mouseleave', function () {
      if (!desktopHover.matches) return;
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    });

    summary.addEventListener('click', function (event) {
      // event.detail > 0 means a real mouse click; keyboard "clicks"
      // (Enter/Space on summary) report detail 0 and keep toggling.
      var url = summary.getAttribute('data-url');
      if (desktopHover.matches && event.detail > 0 && url) {
        event.preventDefault();
        window.location.href = url;
      }
    });
  });
})();
